export default {
  // Header Section
  "discover_your": "உங்கள்",
  "year_analysis": "ஆண்டு பகுப்பாய்வு",
  "yearly_cosmic_insights": "ஆண்டாந்திர அண்ட நுண்ணறிவுகள்",
  "year_analysis_description": "வேத ஜோதிடம் மற்றும் எண்ணியலை அடிப்படையாகக் கொண்ட முழுமையான ஆண்டாந்திர பகுப்பாய்வைப் பெறுங்கள். ஆண்டின் கருப்பொருட்கள், மாதாந்திர முன்கணிப்புகள், சுபக்காலங்கள், சவால்கள் மற்றும் ஆண்டை முழுவதும் வெற்றி பெற தனிப்பயன் வழிகாட்டுதலைப் புரிந்துகொள்ளுங்கள்.",

  "know_your": "உங்கள்",

  // Service Information
  "enter_details_for_year_analysis": "ஆண்டு பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_year_analysis": "முழுமையான ஆண்டு பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_year_analysis_note": "மாதந்தோறும் முன்கணிப்புகள் மற்றும் கால நிர்ணய வழிகாட்டுதலுடன் கூடிய விரிவான ஆண்டாந்திர முன்னறிவிப்பு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_yearly_influence": "உங்கள் பெயர், ஆண்டாந்திர அதிர்வுகளும் சுழற்சிகளும் மீது தாக்கம் செலுத்துகிறது",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_yearly_cycles": "தனிப்பட்ட ஆண்டுச் சுழற்சிகளும் ஆண்டாந்திர முன்கணிப்புகளும் கணக்கிட இவை அவசியம்",
  "analysis_year": "பகுப்பாய்வு ஆண்டு",
  "year_2024": "2024",
  "year_2025": "2025",
  "year_2026": "2026",
  "select_year_for_analysis": "விரிவான பகுப்பாய்வு வேண்டிய ஆண்டைத் தேர்வுசெய்யுங்கள்",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் ஆண்டு பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Year Features
  "complete_yearly_forecast": "முழுமையான ஆண்டாந்திர முன்னறிவிப்பு",
  "monthly_breakdown_analysis": "மாதாந்திர பகுப்பாய்வு முறிவு",
  "major_life_events_timing": "முக்கிய வாழ்க்கை நிகழ்வுகளின் கால நிர்ணயம்",
  "favorable_unfavorable_periods": "சாதக & அதிர்ச்சி காலங்கள்",
  "yearly_remedies_guidance": "ஆண்டிற்கான பரிகாரங்கள் & வழிகாட்டுதல்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் ஆண்டு பகுப்பாய்வில் உள்ளவை",
  "comprehensive_yearly_roadmap": "முழுமையான ஆண்டாந்திர சாலைவரைபடம்",
  "month_by_month_predictions": "மாதந்தோறும் முன்கணிப்புகள்",
  "auspicious_timing_guide": "சுப காலநேர வழிகாட்டி",
  "yearly_remedial_solutions": "ஆண்டிற்கான பரிகாரத் தீர்வுகள்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் ஆண்டு பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "year_analysis_processing": "உங்கள் முழுமையான ஆண்டு பகுப்பாய்வை எங்கள் ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். விரிவான மாதாந்திர முன்கணிப்புகள் மற்றும் ஆண்டாந்திர வழிகாட்டுதல் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_18_hours_delivery_note": "உங்கள் விரிவான ஆண்டு பகுப்பாய்வு 18 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் ஆண்டு பகுப்பாய்வு தொகுப்பு",
  "detailed_year_analysis": "விரிவான ஆண்டு பகுப்பாய்வு அறிக்கை (PDF)",
  "monthly_predictions_calendar": "மாதாந்திர முன்கணிப்பு காலண்டர்",
  "auspicious_dates_timing": "சுப நாட்கள் & நேரங்கள்",
  "yearly_remedies_guide": "ஆண்டிற்கான பரிகார வழிகாட்டி",
  "life_events_forecast": "வாழ்க்கை நிகழ்வு முன்னறிவிப்பு",

  // Visual Content
  "sample_year_analysis": "மாதிரி ஆண்டு பகுப்பாய்வு",
  "yearly_theme": "ஆண்டின் கருப்பொருள்",
  "sample_yearly_reading": "வளர்ச்சி & மாற்றம் — நிதி நிலைத்தன்மையில் அதிக கவனம்",
  "sample_year_preview": "மாதாந்திர நுண்ணறிவுகளுடன் உங்கள் தனிப்பயன் ஆண்டு பகுப்பாய்வின் முன்னோட்டம்",
  "monthly_overview": "மாதாந்திர மேலோட்டம்",

  // Month Abbreviations
  "jan": "ஜன்",
  "feb": "பிப்",
  "mar": "மார்",
  "apr": "ஏப்",
  "may": "மே",
  "jun": "ஜூன்",
  "jul": "ஜூலை",
  "aug": "ஆக",
  "sep": "செப்",
  "oct": "அக்",
  "nov": "நவ",
  "dec": "டிச",
  
  // Status & Processing
  "your_year_analysis_status": "உங்கள் ஆண்டு பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் ஆண்டை ஆய்வு செய்கிறது",
  "analysis_processing_message": "மாதாந்திர முன்கணிப்புகள் மற்றும் காலநேர வழிகாட்டுதலுடன் உங்கள் முழுமையான ஆண்டு பகுப்பாய்வு தயாராகிறது.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_18_hours": "அறிக்கை 18 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "ஆண்டு பகுப்பாய்வு ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Year-Specific Elements
  "personal_year_number": "தனிப்பட்ட ஆண்டு எண்",
  "annual_theme": "ஆண்டாந்திர கருப்பொருள்",
  "year_vibration": "ஆண்டு அதிர்வு",
  "yearly_cycles": "ஆண்டுச் சுழற்சிகள்",
  "annual_lessons": "ஆண்டின் பாடங்கள்",
  "year_challenges": "ஆண்டின் சவால்கள்",

  // Monthly Analysis
  "january_analysis": "ஜனவரி பகுப்பாய்வு",
  "february_analysis": "பிப்ரவரி பகுப்பாய்வு",
  "march_analysis": "மார்ச் பகுப்பாய்வு",
  "april_analysis": "ஏப்ரல் பகுப்பாய்வு",
  "may_analysis": "மே பகுப்பாய்வு",
  "june_analysis": "ஜூன் பகுப்பாய்வு",
  "july_analysis": "ஜூலை பகுப்பாய்வு",
  "august_analysis": "ஆகஸ்ட் பகுப்பாய்வு",
  "september_analysis": "செப்டம்பர் பகுப்பாய்வு",
  "october_analysis": "அக்டோபர் பகுப்பாய்வு",
  "november_analysis": "நவம்பர் பகுப்பாய்வு",
  "december_analysis": "டிசம்பர் பகுப்பாய்வு",

  // Quarterly Analysis
  "first_quarter": "முதல் காலாண்டு (ஜன்-மார்)",
  "second_quarter": "இரண்டாம் காலாண்டு (ஏப்-ஜூன்)",
  "third_quarter": "மூன்றாம் காலாண்டு (ஜூலை-செப்)",
  "fourth_quarter": "நான்காம் காலாண்டு (அக்-டிச)",
  "quarterly_themes": "காலாண்டு கருப்பொருட்கள்",
  "seasonal_influences": "஋து தாக்கங்கள்",

  // Life Areas Yearly Focus
  "career_year_focus": "தொழில் — இந்த ஆண்டின் கவனம்",
  "love_relationships_year": "காதல் & உறவுகள் — இந்த ஆண்டு",
  "health_wellness_year": "ஆரோக்கியம் & நலன் — இந்த ஆண்டு",
  "financial_year_outlook": "நிதி — ஆண்டிருக் கண்ணோட்டம்",
  "family_social_year": "குடும்பம் & சமூக — இந்த ஆண்டு",
  "spiritual_growth_year": "ஆன்மீக வளர்ச்சி — இந்த ஆண்டு",

  // Timing & Periods
  "peak_success_periods": "உச்ச வெற்றி காலங்கள்",
  "challenging_periods": "சவாலான காலங்கள்",
  "neutral_periods": "நடுநிலை காலங்கள்",
  "transformation_phases": "மாற்றக் கட்டங்கள்",
  "opportunity_windows": "வாய்ப்பு காலப் பெட்டிகள்",
  "caution_periods": "எச்சரிக்கை காலங்கள்",

  // Auspicious Timing
  "best_months_for_new_ventures": "புதிய முயற்சிகளுக்கான சிறந்த மாதங்கள்",
  "favorable_travel_periods": "பயணத்திற்கு சாதகமான காலங்கள்",
  "auspicious_wedding_dates": "சுப திருமண தேதிகள்",
  "good_investment_timing": "முதலீட்டுக்கான உகந்த நேரம்",
  "career_change_timing": "தொழில் மாற்றத்திற்கான நேரம்",
  "property_purchase_timing": "சொத்து வாங்குவதற்கான நேரம்",

  // Annual Predictions
  "career_predictions": "தொழில் முன்கணிப்புகள்",
  "business_forecast": "வணிக முன்னறிவிப்பு",
  "financial_outlook": "நிதி கண்ணோட்டம்",
  "relationship_predictions": "உறவு முன்கணிப்புகள்",
  "health_forecast": "ஆரோக்கிய முன்னறிவிப்பு",
  "family_predictions": "குடும்ப முன்கணிப்புகள்",

  // Success Factors
  "key_success_factors": "வெற்றிக்கான முக்கிய காரணிகள்",
  "growth_opportunities": "வளர்ச்சி வாய்ப்புகள்",
  "skill_development_focus": "திறன் மேம்பாட்டு கவனம்",
  "networking_opportunities": "நெட்வொர்க்கிங் வாய்ப்புகள்",
  "leadership_potential": "தலைமை திறன்",
  "creative_expression": "படைப்பு வெளிப்பாடு",

  // Challenges & Solutions
  "potential_obstacles": "சாத்தியமான தடைகள்",
  "problem_solving_guidance": "சிக்கல் தீர்க்கும் வழிகாட்டுதல்",
  "stress_management": "மனஅழுத்த மேலாண்மை",
  "conflict_resolution": "மோதல் தீர்வு",
  "decision_making_support": "முடிவு எடுப்பதற்கான ஆதரவு",
  "risk_mitigation": "அபாயக் குறைப்புப் உத்திகள்",

  // Personal Development
  "character_development": "குணநிலை வளர்ச்சி",
  "habit_formation": "பயனுள்ள பழக்கங்கள் உருவாக்குதல்",
  "goal_setting_guidance": "இலக்குகள் அமைக்கும் வழிகாட்டுதல்",
  "motivation_factors": "உந்துதல் காரணிகள்",
  "confidence_building": "நம்பிக்கை வளர்ப்பு",
  "self_improvement_areas": "சுய மேம்பாட்டு தளங்கள்",

  // Relationship Year
  "love_life_forecast": "காதல் வாழ்க்கை முன்னறிவிப்பு",
  "marriage_prospects": "திருமண வாய்ப்புகள்",
  "family_harmony": "குடும்ப ஒற்றுமை",
  "friendship_developments": "நட்பு முன்னேற்றங்கள்",
  "social_connections": "சமூக இணைப்புகள்",
  "partnership_opportunities": "கூட்டாண்மை வாய்ப்புகள்",

  // Financial Year
  "income_growth_potential": "வருமான வளர்ச்சி திறன்",
  "expenditure_patterns": "செலவு முறைபாடுகள்",
  "investment_guidance": "முதலீட்டு வழிகாட்டுதல்",
  "debt_management": "கடன் மேலாண்மை",
  "savings_opportunities": "சேமிப்பு வாய்ப்புகள்",
  "financial_planning": "நிதித் திட்டமிடல்",

  // Health Year
  "vitality_levels": "உயிர்ச்சக்தி நிலைகள்",
  "health_maintenance": "ஆரோக்கிய பராமரிப்பு",
  "fitness_goals": "உடற்பயிற்சி இலக்குகள்",
  "wellness_practices": "நலன் நடைமுறைகள்",
  "preventive_care": "முன்னெச்சரிக்கை பராமரிப்பு",
  "mental_health_focus": "மனநலம் — கவனம்",

  // Career Year
  "professional_growth": "தொழில்முறை வளர்ச்சி",
  "job_opportunities": "வேலை வாய்ப்புகள்",
  "skill_enhancement": "திறன் மேம்பாடு",
  "leadership_roles": "தலைமைப் பொறுப்புகள்",
  "career_transitions": "தொழில் இடமாற்றங்கள்",
  "recognition_achievements": "மரியாதை & சாதனைகள்",

  // Spiritual Year
  "spiritual_awakening": "ஆன்மீக விழிப்பு",
  "meditation_practices": "தியானப் பயிற்சிகள்",
  "inner_growth": "உள் வளர்ச்சி",
  "wisdom_development": "ஞான வளர்ச்சி",
  "divine_connections": "தெய்வீக இணைப்புகள்",
  "karmic_lessons": "கர்மப் பாடங்கள்",

  // Travel & Adventure
  "travel_opportunities": "பயண வாய்ப்புகள்",
  "adventure_potential": "சாகசத் திறன்",
  "cultural_experiences": "கலாச்சார அனுபவங்கள்",
  "educational_journeys": "கல்வி பயணங்கள்",
  "pilgrimage_possibilities": "புனிதப் பயண வாய்ப்புகள்",
  "foreign_connections": "வெளிநாட்டு இணைப்புகள்",

  // Learning & Education
  "skill_certifications": "திறன் சான்றிதழ்கள்",
  "knowledge_expansion": "அறிவு விரிவு",
  "teaching_possibilities": "கற்பித்தல் வாய்ப்புகள்",
  "research_projects": "ஆராய்ச்சி திட்டங்கள்",
  "academic_pursuits": "கல்விசார் முயற்சிகள்",

  // Creative & Artistic
  "creative_projects": "படைப்பு திட்டங்கள்",
  "artistic_expression": "கலை வெளிப்பாடு",
  "innovative_ideas": "புதுமை கருத்துகள்",
  "creative_collaborations": "படைப்பு கூட்டாண்மைகள்",
  "artistic_recognition": "கலை மரியாதை",
  "creative_income": "படைப்பு வருமான திறன்",

  // Social & Community
  "community_involvement": "சமூக பங்களிப்பு",
  "social_influence": "சமூக செல்வாக்கு",
  "public_recognition": "பொது மரியாதை",
  "group_activities": "குழு செயல்பாடுகள்",
  "social_causes": "சமூக காரணிகள்",
  "humanitarian_work": "மனிதநேயச் சேவை",

  // Technology & Innovation
  "technological_adaptation": "தொழில்நுட்ப தழுவல்",
  "digital_opportunities": "டிஜிட்டல் வாய்ப்புகள்",
  "innovation_potential": "புதுமை திறன்",
  "online_presence": "ஆன்லைன் முன்னிலை",
  "tech_skill_development": "டெக் திறன் மேம்பாடு",
  "digital_transformation": "டிஜிட்டல் மாற்றம்"
};
